import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6885809e")

_pushScopeId("data-v-6885809e")
const _hoisted_1 = { style: {"float":"left"} }
const _hoisted_2 = { class: "version_center" }
const _hoisted_3 = { class: "version_center_main" }
const _hoisted_4 = { style: {"text-align":"center","background-color":"#409eff","font-size":"14px","color":"white","font-weight":"bolder","margin-bottom":"20px","padding":"10px 0"} }
const _hoisted_5 = { class: "version_center_table" }
const _hoisted_6 = { colspan: "2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 异常截图共")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("张 ")
const _hoisted_9 = { colspan: "2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 标记为异常截图")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("张(全画质) ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 其中局内")
const _hoisted_13 = { class: "redTd" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("张 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 局外")
const _hoisted_16 = { class: "redTd" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("张 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 其中局内")
const _hoisted_19 = { class: "redTd" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("张 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 局外")
const _hoisted_22 = { class: "redTd" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("张 ")
const _hoisted_24 = { class: "img_table" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_26 = { class: "redTd" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("张")
const _hoisted_28 = { class: "redTd" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("张")
const _hoisted_30 = { class: "redTd" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("张")
const _hoisted_32 = { class: "draw_box" }
const _hoisted_33 = { style: {"width":"96%","margin":"auto"} }
const _hoisted_34 = { style: {"border":"1px solid #d9d9d9","border-radius":"5px","padding":"2px 0","display":"flex","justify-content":"space-between"} }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("【")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("】")
const _hoisted_38 = /*#__PURE__*/_createVNode("span", null, "【自动识别:", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("】")
const _hoisted_40 = /*#__PURE__*/_createVNode("span", null, /*#__PURE__*/_toDisplayString("【人工标记:"), -1)
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("】")
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-arrow-left",
  style: {"font-size":"50px","color":"#fff"}
}, null, -1)
const _hoisted_45 = {
  id: "center",
  style: {"width":"92%","position":"relative","height":"100%","overflow":"hidden"}
}
const _hoisted_46 = {
  id: "imgBox",
  style: {"position":"absolute","top":"0","left":"0","background":"#ff0","display":"flex","transition":"0.5s"}
}
const _hoisted_47 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-arrow-right",
  style: {"font-size":"50px","color":"#fff"}
}, null, -1)
const _hoisted_48 = { style: {"display":"flex","justify-content":"space-around"} }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("标记为正常")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("白模")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("黑模")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("紫模")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("光照异常")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("画面卡住")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("对比异常")
const _hoisted_56 = /*#__PURE__*/_createTextVNode("方块异常")
const _hoisted_57 = { style: {"text-align":"right","font-size":"14px","font-weight":"bolder","margin-bottom":"20px","padding":"10px 0"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { class: "tableMinH" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    class: "spacForm",
                    size: "mini",
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "时间" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.date_version,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.date_version = $event)),
                            placeholder: "请选择",
                            onChange: _ctx.dateChange
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.date,
                                  value: item.date
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "版本" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.pkg,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.pkg = $event)),
                            placeholder: "请选择",
                            onChange: _ctx.pkgChange
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pkgList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.pkg,
                                  label: item.pkg.split('_')[3] + '_' + item.pkg.split('_')[4],
                                  value: item.pkg
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "局内/局外" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.scene,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.scene = $event)),
                            placeholder: "请选择",
                            onChange: _ctx.sceneChange
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "画质" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.drawChange,
                            modelValue: _ctx.form.draw,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.draw = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.scene == '1'
                    ? _ctx.skinLineViewOut
                    : _ctx.skinLineViewIn, (item, k, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: k,
                                  value: k
                                }, {
                                  default: _withId(() => [
                                    _createVNode("span", _hoisted_1, _toDisplayString(k), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "筛选" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.screenChange,
                            modelValue: _ctx.form.screen,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.screen = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.screenList, (item, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: item.name,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_2, [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, " 当前版本全截图" + _toDisplayString(_ctx.get_data.image_nums.total_num) + "张 ", 1),
                      _createVNode("table", _hoisted_5, [
                        _createVNode("thead", null, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_6, [
                              _hoisted_7,
                              _createVNode("span", null, _toDisplayString(_ctx.get_data.in_bad_nums + _ctx.get_data.out_bad_nums), 1),
                              _hoisted_8
                            ]),
                            _createVNode("td", _hoisted_9, [
                              _hoisted_10,
                              _createVNode("span", null, _toDisplayString(_ctx.get_data.mark_nums), 1),
                              _hoisted_11
                            ])
                          ])
                        ]),
                        _createVNode("tbody", null, [
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_12,
                              _createVNode("span", _hoisted_13, _toDisplayString(_ctx.get_data.in_bad_nums), 1),
                              _hoisted_14
                            ]),
                            _createVNode("td", null, [
                              _hoisted_15,
                              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.get_data.out_bad_nums), 1),
                              _hoisted_17
                            ]),
                            _createVNode("td", null, [
                              _hoisted_18,
                              _createVNode("span", _hoisted_19, _toDisplayString(_ctx.get_data.in_mark_nums), 1),
                              _hoisted_20
                            ]),
                            _createVNode("td", null, [
                              _hoisted_21,
                              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.get_data.out_mark_nums), 1),
                              _hoisted_23
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_24, [
                        _createVNode(_component_el_table, {
                          data: _ctx.imgTableData(_ctx.form.scene, _ctx.form.draw),
                          border: "",
                          "header-cell-style": {
                    background: '#f5f7fa',
                    color: '#595757',
                  },
                          "header-row-style": { height: '32px' }
                        }, {
                          default: _withId(() => [
                            _hoisted_25,
                            _createVNode(_component_el_table_column, {
                              label: "画质",
                              width: "290.75",
                              align: "center"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, [
                                  _createVNode("span", null, _toDisplayString(scope.row.name), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "标记为异常",
                              width: "290.75",
                              align: "center"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, [
                                  _createVNode("span", _hoisted_26, _toDisplayString(scope.row.mark), 1),
                                  _hoisted_27
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "局内异常",
                              width: "290.75",
                              align: "center"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, [
                                  _createVNode("span", _hoisted_28, _toDisplayString(scope.row.inMark), 1),
                                  _hoisted_29
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "局外异常",
                              width: "290.75",
                              align: "center"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, [
                                  _createVNode("span", _hoisted_30, _toDisplayString(scope.row.outMark), 1),
                                  _hoisted_31
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_32, [
                        _createVNode("div", _hoisted_33, [
                          _createVNode("div", _hoisted_34, [
                            _createVNode("div", null, [
                              (_ctx.typeName(_ctx.auto_abnormal_type) === '对比异常')
                                ? (_openBlock(), _createBlock("span", _hoisted_35, "【新版本】"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", null, [
                              _createVNode("span", null, _toDisplayString("【共" + _ctx.total + "张图片,当前第" + _ctx.numIndex + "张】"), 1),
                              _createVNode("span", null, [
                                _hoisted_36,
                                _createVNode("span", null, _toDisplayString(_ctx.imgStatus != 2 ? "已标记" : "未标记"), 1),
                                _hoisted_37
                              ]),
                              _createVNode("span", null, [
                                _hoisted_38,
                                _createVNode("span", {
                                  class: 
                            _ctx.typeName(_ctx.auto_abnormal_type) != '正常'
                              ? 'redTd'
                              : 'greenTd'
                          
                                }, _toDisplayString(_ctx.typeName(_ctx.auto_abnormal_type)), 3),
                                _hoisted_39
                              ]),
                              _createVNode("span", null, [
                                _hoisted_40,
                                (_ctx.imgStatus != 2)
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      class: 
                            _ctx.typeName(_ctx.abnormal_type) != '正常'
                              ? 'redTd'
                              : 'greenTd'
                          
                                    }, _toDisplayString(_ctx.typeName(_ctx.abnormal_type)), 3))
                                  : (_openBlock(), _createBlock("span", _hoisted_41, "--")),
                                _hoisted_42
                              ])
                            ]),
                            _createVNode("div", null, [
                              (_ctx.typeName(_ctx.auto_abnormal_type) === '对比异常')
                                ? (_openBlock(), _createBlock("span", _hoisted_43, "【旧版本】"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("div", {
                            style: 
                      'display:flex;justify-content: space-between;margin: 10px 0;' +
                      'height:' +
                      _ctx.imgHeight
                    
                          }, [
                            _createVNode("div", {
                              id: "leftBtn",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.leftBtn && _ctx.leftBtn(...args))),
                              style: {"width":"3%","background":"#c9caca","border-radius":"5px","display":"flex","justify-content":"center","align-items":"center"}
                            }, [
                              _hoisted_44
                            ]),
                            _createVNode("div", _hoisted_45, [
                              _createVNode("div", _hoisted_46, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skinLineView, (item, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    style: {
                            width: _ctx.imgWidth + 'px',
                            maxHeight: _ctx.imgHeight,
                          },
                                    key: index,
                                    id: index
                                  }, [
                                    _createVNode("img", {
                                      style: {"width":"100%","heigth":"100%"},
                                      src: item.file_path
                                    }, null, 8, ["src"])
                                  ], 12, ["id"]))
                                }), 128))
                              ])
                            ]),
                            _createVNode("div", {
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.rightBtn && _ctx.rightBtn(...args))),
                              id: "rightBtn",
                              style: {"width":"3%","background":"#e5efff","border-radius":"5px","display":"flex","justify-content":"center","align-items":"center"}
                            }, [
                              _hoisted_47
                            ])
                          ], 4),
                          _createVNode("div", _hoisted_48, [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              style: {"width":"10%","height":"50px"},
                              type: "primary"
                            }, {
                              default: _withId(() => [
                                _createVNode("a", {
                                  href: _ctx.file_path,
                                  download: "",
                                  style: {"color":"#fff","cursor":"pointer","text-decoration":"none","width":"10%","height":"50px"}
                                }, "下载", 8, ["href"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              style: {"width":"10%","height":"50px"},
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.detail('success'))),
                              type: "success"
                            }, {
                              default: _withId(() => [
                                _hoisted_49
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              style: {"width":"10%","height":"50px"},
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.detail('error', 'white_result')))
                            }, {
                              default: _withId(() => [
                                _hoisted_50
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              style: {"width":"10%","height":"50px"},
                              class: "blackBtn",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.detail('error', 'black_result')))
                            }, {
                              default: _withId(() => [
                                _hoisted_51
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              style: {"width":"10%","height":"50px"},
                              class: "edit",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.detail('error', 'purple_result')))
                            }, {
                              default: _withId(() => [
                                _hoisted_52
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              style: {"width":"10%","height":"50px"},
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.detail('error', 'light')))
                            }, {
                              default: _withId(() => [
                                _hoisted_53
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              style: {"width":"10%","height":"50px"},
                              type: "danger",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.detail('error', 'stuck')))
                            }, {
                              default: _withId(() => [
                                _hoisted_54
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              style: {"width":"10%","height":"50px"},
                              type: "warning",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.detail('error', 'compare_result')))
                            }, {
                              default: _withId(() => [
                                _hoisted_55
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              style: {"width":"10%","height":"50px"},
                              type: "info",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.detail('error', 'rect_result')))
                            }, {
                              default: _withId(() => [
                                _hoisted_56
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ], 512), [
                        [_vShow, _ctx.skinLineView?.length > 0]
                      ]),
                      _createVNode("div", _hoisted_57, " 当前版本已确认：" + _toDisplayString(_ctx.get_data.manual_mark_nums) + "张 ", 1),
                      _withDirectives(_createVNode("div", null, [
                        _createVNode(_component_el_empty, { description: "无数据" })
                      ], 512), [
                        [_vShow, _ctx.skinLineView?.length <= 0]
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})